const defaultState = {
  isSignInModalOpen: false,
  isEmailVerificationBannerVisible: false,
  isEmailVerificationBannerDismissed: false,
  isCookiesBarVisible: false,
  signInModalMessage: null,
  openedProfile: {
    info: null,
    followers: {
      data: [],
      hasMore: true,
    },
    following: {
      data: [],
      hasMore: true,
    },
    collections: {
      data: [],
      hasMore: true,
    },
  },
  //can be used to tracks user overall actions and act based on it
  stats: {
    //increment likes
    likesCount: 0,
  },
  onboarding: {
    isOnboardingDimmerOpen: false,
    isProfileUpdateDimmerOpen: false,
    onboardingMessage: "",
    onboardingDisplayFields: null,
  },
  // TODO:
  isUserProfileFetched: false,
  // TODO:
  isFetchingUserProfile: false,
  // profile: undefined || {}, // includes data stored on firebase // TODO: add it to defualt
  // includes data stored on our db TODO
  extraData: {},
  // TODO: to indicate if we finished checking user auth state or not
  userAuthStateChecked: false,
  // TODO: track user and verif if he's logged in
  isAuthorized: false,

  isCreatingProfile: false,
  isSSRUser: false,
};

const toggleListUserIsFollow = (userId, users) =>
  users && users.map(user => (user.id === userId ? { ...user, isFollowed: !user.isFollowed } : user));

const toggleFollowProfileInfo = (state, actionUserId, counterChangeValue) => {
  const profileInfo = state.openedProfile.info;
  const toggledFollowProfileInfo = {};
  toggledFollowProfileInfo.isFollowed =
    profileInfo._id === actionUserId ? !profileInfo.isFollowed : profileInfo.isFollowed;
  if (state.profile.uid === profileInfo._id) {
    toggledFollowProfileInfo.totalFollowing = profileInfo.totalFollowing + counterChangeValue;
  } else if (actionUserId === profileInfo._id) {
    toggledFollowProfileInfo.totalFollowers = profileInfo.totalFollowers + counterChangeValue;
  }
  return toggledFollowProfileInfo;
};

const User = (state = defaultState, action) => {
  switch (action.type) {
    case "FETCHING_USER_PROFILE": {
      return {
        ...state,
        isFetchingUserProfile: action.payload,
      };
    }

    case "IS_USER_PROFILE_FETCHED": {
      return {
        ...state,
        fetchedUserProfile: action.payload,
      };
    }

    case "SHOW_ONBOARDING_DIMMER": {
      return {
        ...state,
        onboarding: {
          ...state.onboarding,
          isOnboardingDimmerOpen: true,
          onboardingMessage: action.onboardingMessage,
          onboardingDisplayFields: action.onboardingDisplayFields,
        },
      };
    }

    case "HIDE_ONBOARDING_DIMMER": {
      return {
        ...state,
        onboarding: {
          ...state.onboarding,
          isOnboardingDimmerOpen: false,
        },
      };
    }

    case "SHOW_PROFILE_UPDATE_DIMMER": {
      return {
        ...state,
        onboarding: {
          ...state.onboarding,
          isProfileUpdateDimmerOpen: true,
          onboardingMessage: action.onboardingMessage,
          onboardingDisplayFields: action.onboardingDisplayFields,
        },
      };
    }

    case "HIDE_PROFILE_UPDATE_DIMMER": {
      return {
        ...state,
        onboarding: {
          ...state.onboarding,
          isProfileUpdateDimmerOpen: false,
          onboardingMessage: "",
          onboardingDisplayFields: null,
        },
      };
    }

    case "IS_CREATING_PROFILE": {
      return {
        ...state,
        isCreatingProfile: action.payload,
      };
    }

    case "LOAD_MORE_USER_POSTS_SUCCESS": {
      const { override = false, limit, posts: fetchedPosts } = action;
      const { posts: statePosts } = state;
      if (fetchedPosts.length < limit) {
        return {
          ...state,
          posts: { data: [...statePosts, ...fetchedPosts], hasMore: false },
        };
      }
      if (override) {
        return { ...state, posts: { data: [...fetchedPosts] } };
      }
      return { ...state, posts: { data: [...statePosts, ...fetchedPosts] } };
    }

    case "SET_USER":
    case "LOGIN": {
      return { ...state, profile: action.profile, isEmailVerificationBannerVisible: !action.profile.isEmailVerified };
    }

    case "SIGNOUT":
    case "CLEAR_USER": {
      return { ...state, profile: null };
    }

    case "SHOW_USER_SIGN_IN_MODAL": {
      return {
        ...state,
        isSignInModalOpen: true,
        signInModalMessage: action.message,
      };
    }

    case "HIDE_USER_SIGN_IN_MODAL": {
      return {
        ...state,
        isSignInModalOpen: false,
        signInModalMessage: null,
      };
    }

    case "LOAD_OPENED_PROFILE_INFO_SUCCESS":
      return {
        ...state,
        openedProfile: {
          ...state.openedProfile,
          info: action.user,
        },
      };

    case "CLEAN_OPENED_PROFILE":
      return {
        ...state,
        openedProfile: {
          ...state.openedProfile,
          info: null,
          followers: {
            data: [],
            hasMore: true,
          },
          following: {
            data: [],
            hasMore: true,
          },
          collections: {
            data: [],
            hasMore: true,
          },
        },
      };

    case "UNFOLLOW_USER_FAILED":
    case "FOLLOW_USER_OPTIMISTIC":
      if (!state.openedProfile.info) {
        return state;
      }

      return {
        ...state,
        openedProfile: {
          ...state.openedProfile,
          info: {
            ...state.openedProfile.info,
            ...toggleFollowProfileInfo(state, action.userId, 1),
          },
          followers: {
            ...state.openedProfile.followers,
            data: toggleListUserIsFollow(action.userId, state.openedProfile.followers.data),
          },
          following: {
            ...state.openedProfile.following,
            data: toggleListUserIsFollow(action.userId, state.openedProfile.following.data),
          },
        },
      };

    case "UNFOLLOW_USER_OPTIMISTIC":
    case "FOLLOW_USER_FAILED":
      if (!state.openedProfile.info) {
        return state;
      }

      return {
        ...state,
        openedProfile: {
          ...state.openedProfile,
          info: {
            ...state.openedProfile.info,
            ...toggleFollowProfileInfo(state, action.userId, -1),
          },
          followers: {
            ...state.openedProfile.followers,
            data: toggleListUserIsFollow(action.userId, state.openedProfile.followers.data),
          },
          following: {
            ...state.openedProfile.following,
            data: toggleListUserIsFollow(action.userId, state.openedProfile.following.data),
          },
        },
      };

    case "LOAD_MORE_OPENED_PROFILE_FOLLOWING_SUCCESS": {
      const { following: fetchedFollowing, pagingToken, limit } = action;
      const hasMore = !(fetchedFollowing.length < limit);

      return {
        ...state,
        openedProfile: {
          ...state.openedProfile,
          following: {
            data: action.override ? fetchedFollowing : [...state.openedProfile.following.data, ...fetchedFollowing],
            hasMore,
            pagingToken,
          },
        },
      };
    }

    case "LOAD_MORE_OPENED_PROFILE_FOLLOWERS_SUCCESS": {
      const { followers: fetchedFollowers, pagingToken, limit } = action;
      const hasMore = !(fetchedFollowers.length < limit);

      return {
        ...state,
        openedProfile: {
          ...state.openedProfile,
          followers: {
            data: action.override ? fetchedFollowers : [...state.openedProfile.followers.data, ...fetchedFollowers],
            hasMore,
            pagingToken,
          },
        },
      };
    }

    case "LOAD_MORE_OPENED_PROFILE_COLLECTIONS_SUCCESS": {
      const { collections: fetchedCollections, pagingToken, limit } = action;
      const hasMore = !(fetchedCollections.length < limit);
      return {
        ...state,
        openedProfile: {
          ...state.openedProfile,
          collections: {
            data: [...state.openedProfile.collections.data, ...fetchedCollections],
            hasMore,
            pagingToken,
          },
        },
      };
    }

    case "CREATE_COLLECTION_SUCCESS": {
      const newCollection = action.newCollection;
      return {
        ...state,
        openedProfile: {
          ...state.openedProfile,
          collections: {
            ...state.openedProfile.collections,
            data: [newCollection, ...state.openedProfile.collections.data],
          },
        },
      };
    }

    case "INCREMENT_USER_LIKES": {
      return {
        ...state,
        stats: {
          ...state.stats,
          likesCount: state.stats.likesCount + 1,
        },
      };
    }

    case "HIDE_EMAIL_VERIFICATION_BANNER": {
      return {
        ...state,
        isEmailVerificationBannerDismissed: true,
      };
    }

    case "SHOW_COOKIES_BAR": {
      return {
        ...state,
        isCookiesBarVisible: true,
      };
    }

    case "HIDE_COOKIES_BAR": {
      return {
        ...state,
        isCookiesBarVisible: false,
      };
    }

    case "SET_SSR_USER_FLAG": {
      return {
        ...state,
        isSSRUser: action.value,
      };
    }

    default:
      return state;
  }
};

export default User;



// WEBPACK FOOTER //
// ./src/reducers/User/index.js